import React from "react"
import { HeaderSection } from "../../common/headers/HeaderSection";
import FreeCourseScheduleSection from "./FreeCourseBanner";
import { CourseSchedule } from "@/interfaces/CourseSchedule";

const backendWeek1FreeCourseSchedule: CourseSchedule[] = [
    {
        id: 1,
        programTitle: 'Back-End Website',
        date: '11 Desember 2023',
        day: 'Jumat',
        time: '19.00 - selesai',
    },
];
const backendWeek2FreeCourseSchedule: CourseSchedule[] = [
    {
        id: 2,
        programTitle: 'Back-End Website',
        date: '18 Desember 2023',
        day: 'Kamis',
        time: '19.00 - selesai',
    },
];
const backendWeek3FreeCourseSchedule: CourseSchedule[] = [
    {
        id: 3,
        programTitle: 'Back-End Website',
        date: '22 Desember 2023',
        day: 'Kamis',
        time: '19.00 - selesai',
    },
];

const BackEndFreeCourseSchedule = () => {
    return (
        <div className="px-5 md:px-10">
            <HeaderSection
                title="Jadwal Program"
                subtitle="Pilih dan daftar jadwal program yang tersedia"
            />
            <FreeCourseScheduleSection schedule={backendWeek1FreeCourseSchedule} />
            <FreeCourseScheduleSection schedule={backendWeek2FreeCourseSchedule} />
            <FreeCourseScheduleSection schedule={backendWeek3FreeCourseSchedule} />
        </div>
    );
};

export default BackEndFreeCourseSchedule;
